// After Create/Review/Revise/Approve forms: Tenant/Client close or go to /main; Fraport/admin return to Execution/Builder.
// Token-only flows pass user=null → treated as external (no deep-link into portfolio).

import type { NavigateFunction } from 'react-router-dom';
import type { User } from '../services/authApi';
import { hasAnyRole, isFraportUser } from '../services/authApi';

/** Shown on success when Close/navigation is hidden (external users; tab often cannot be closed by script). */
export const EXTERNAL_ACTION_FORM_COMPLETION_MESSAGE =
  'Action completed successfully. You may close this page.';

export function shouldNavigateIntoPortfolioAfterAction(user: User | null): boolean {
  if (!user) return false;
  if (isFraportUser(user)) return true;
  return hasAnyRole(user, ['System Admin', 'Exec Admin', 'Airport Manager', 'Fraport User']);
}

export function dismissAfterActionForm(
  navigate: NavigateFunction,
  user: User | null,
  options: {
    internalProjectId?: number | null;
    internalFallbackPath?: string;
  } = {}
): void {
  const { internalProjectId, internalFallbackPath = '/builder' } = options;
  if (shouldNavigateIntoPortfolioAfterAction(user)) {
    if (internalProjectId != null && !Number.isNaN(internalProjectId)) {
      navigate(`/execution?projectId=${internalProjectId}`);
    } else {
      navigate(internalFallbackPath);
    }
    return;
  }
  if (window.opener) {
    window.close();
    return;
  }
  navigate('/main');
}
